import Bars3Icon from "@heroicons/react/24/solid/Bars3Icon";
import { useState } from "react";
import {
  Avatar,
  Box,
  IconButton,
  Stack,
  SvgIcon,
  useMediaQuery,
} from "@mui/material";
import { usePopover } from "../../../hooks/use-popover";
import { SalesAccountPopover } from "./SalesAccountPopover";
import { useSalesAuth } from "../../../hooks/useSalesAuth";

const TOP_NAV_HEIGHT = 64;

const SalesTopNav = ({ onNavOpen, togleNav, openNav, sideNavWidth = 280 }) => {
  const { user } = useSalesAuth();
  const lgUp = useMediaQuery((theme) => theme.breakpoints.up("lg"));
  const accountPopover = usePopover();
  const [avatarUrl, setAvatarUrl] = useState("");

  // Get user initials for avatar
  const getInitials = () => {
    if (user?.full_name) {
      const names = user.full_name.split(" ");
      if (names.length >= 2) {
        return `${names[0][0]}${names[1][0]}`.toUpperCase();
      }
      return names[0][0]?.toUpperCase() || "S";
    }
    return user?.email?.[0]?.toUpperCase() || "S";
  };

  return (
    <>
      <Box sx={{ position: "relative" }}>
        <Stack
          alignItems="center"
          direction="row"
          justifyContent="space-between"
          spacing={2}
          sx={{
            minHeight: TOP_NAV_HEIGHT,
            px: 2,
            ml: {
              xs: openNav && !lgUp ? `${sideNavWidth}px` : 0,
              lg: 0,
            },
            // width: "100%",
            transition: "margin-left 0.3s ease-in-out",
          }}
        >
          <Stack alignItems="center" direction="row" spacing={2}>
            {!lgUp && !openNav && (
              <IconButton onClick={onNavOpen} sx={{ display: "block" }}>
                <SvgIcon fontSize="small">
                  <Bars3Icon />
                </SvgIcon>
              </IconButton>
            )}
          </Stack>

          <Stack alignItems="center" direction="row" spacing={2}>
            <Avatar
              onClick={accountPopover.handleOpen}
              ref={accountPopover.anchorRef}
              sx={{
                cursor: "pointer",
                height: 40,
                width: 40,
                bgcolor: "primary.main",
              }}
              src={avatarUrl}
            >
              {!avatarUrl && getInitials()}
            </Avatar>
          </Stack>
        </Stack>
      </Box>
      <SalesAccountPopover
        setAvatarUrl={setAvatarUrl}
        avatarUrl={avatarUrl}
        anchorEl={accountPopover.anchorRef.current}
        open={accountPopover.open}
        onClose={accountPopover.handleClose}
      />
    </>
  );
};

export default SalesTopNav;
